import { ChangeDetectionStrategy, Component } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'

import { EuKuluttajamyyntiDialog } from './dialogit/eu-kuluttajamyynti.dialog'

@Component({
  selector: 'app-eu-kuluttajamyynti-huomautus',
  templateUrl: './eu-kuluttajamyynti-huomautus.component.html',
  styleUrls: ['./eu-kuluttajamyynti-huomautus.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EuKuluttajamyyntiHuomautusComponent {
  constructor(private _dialog: MatDialog) {}

  avaaLueLisaa() {
    this._dialog.open(EuKuluttajamyyntiDialog, { maxWidth: '560px' })
  }
}
